import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Hub/connection icon.
 *
 * A central node with 4 radiating lines to smaller circles at the
 * edges. Represents a connection hub, network topology, or service
 * mesh relationships.
 *
 * Dual-tone layered:
 * - Outlines: currentColor, 2px stroke, round caps/joins
 * - Central circle area: cyan accent fill at 8%
 * - Center node dot: cyan fill with white inner dot
 * - Outer circles: small (r=2) with currentColor stroke
 */
export const ConnectionIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <RushaSvgIcon size={size}>
    {/* Central circle area with cyan accent fill */}
    <circle
      cx="12"
      cy="12"
      r="5"
      fill="#00d4ff"
      fillOpacity={0.08}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Radiating lines to outer nodes */}
    <path
      d="M12 7 L12 4"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 17 L12 20"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 12 L4 12"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 12 L20 12"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Outer node circles (r=2) with currentColor stroke */}
    <circle
      cx="12"
      cy="3"
      r="2"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="12"
      cy="21"
      r="2"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="3"
      cy="12"
      r="2"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="21"
      cy="12"
      r="2"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Center node dot: cyan fill with white inner dot */}
    <circle cx="12" cy="12" r={1.8} fill="#00d4ff" />
    <circle cx="12" cy="12" r={0.7} fill="white" />
  </RushaSvgIcon>
);

ConnectionIcon.displayName = "ConnectionIcon";

export default ConnectionIcon;
